import { Users } from 'lucide-react';
import type { ReactNode } from 'react';

import { AppLayout } from '../components/AppLayout';
import type { SidebarNavItem } from '../components/Sidebar';

const NAV_ITEMS: SidebarNavItem[] = [
  { path: '/admin/users', label: 'Quản lý người dùng', icon: Users },
];

export function AdminLayout({ children }: { children?: ReactNode }) {
  return (
    <AppLayout navItems={NAV_ITEMS} logoAccent="Admin">
      {children}
    </AppLayout>
  );
}
